import { commonWebSocket } from '@services/common/common.constants';
import { createReducer } from 'redux-act';
import { IFlowPost } from '@app-types/websocket/imageflow.types';

const defaultState:{posts:IFlowPost[]} = {
  posts : [],
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.replace.FLOW_POST_UPDATE, (state:any, payload:any) => {
    if (!Array.isArray(payload?.flowPosts)) {
      return state;
    }

    const posts:IFlowPost[] = Array.isArray(state.posts) ? state.posts.slice() : [];

    for (const fp of payload.flowPosts) {
      if (!fp || typeof fp !== "object") {
        continue;
      }
      const newFlowPost:IFlowPost = fp;
      const index = posts.findIndex((flowPost) => flowPost.postId === newFlowPost.postId);
      if (index === -1) {
        posts.unshift(newFlowPost);
      } else {
        posts[index] = newFlowPost;
      }
    }

    posts.sort((a,b)=>b.postId - a.postId);

    return {
      ...state,
      posts
    };
  })
  .on(commonWebSocket.special.FLOW_POST_REMOVED, (state:any, payload:any) => {

    const posts:IFlowPost[] = Array.isArray(state.posts) ? state.posts.slice() : [];
    const index = posts.findIndex((post) => post.postId === payload.removedFlowPost);
    
    if (index !== -1) {
      posts.splice(index,1);
    }

    return {
      ...state,
      posts
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/imageflow/imageflow.reducer.ts